@if (hasPackageItems()) {
  <div class="mt-8">
    <h2>{{ 'common.order.packageItems' | actrans }}</h2>
    @for (p of packageItems(); track p.id) {
      <div nz-row [nzGutter]="16" class="mt-1">
        <div nz-col [nzSpan]="12">
          {{ p.relatedProductName }}
        </div>
        <div nz-col [nzSpan]="12" class="text-right">
          <nz-input-number
            [ngModel]="p.quantity"
            (ngModelChange)="updateQuantity(p.id, $event)"
            [nzMin]="0"
            [nzStep]="1">
          </nz-input-number>
          @if (p.amount != null) {
            <span class="ml-1">{{ p.amount | nf }}</span>
          }
        </div>
      </div>
    }
  </div>
}
